import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { message, notification } from 'antd';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { humanizeGenericApiError } from './utils/errorMessages';

const patchAntdErrorSurface = (api) => {
  const originalError = api.error.bind(api);
  api.error = (content, ...args) => {
    const sanitized =
      typeof content === 'string'
        ? humanizeGenericApiError(content)
        : content;
    return originalError(sanitized, ...args);
  };
};

patchAntdErrorSurface(message);
patchAntdErrorSurface(notification);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
